import isWebColor from "../../modules/isWebColor";
import { processColor } from "../../modules/processColor";
const normalizeColor = (color, opacity = 1) => {
  if (color == null)
    return;
  if (typeof color === "string" && isWebColor(color)) {
    return color;
  }
  const colorInt = processColor(color);
  if (colorInt != null) {
    const r = colorInt >> 16 & 255;
    const g = colorInt >> 8 & 255;
    const b = colorInt & 255;
    const a = (colorInt >> 24 & 255) / 255;
    const alpha = (a * opacity).toFixed(2);
    return `rgba(${r},${g},${b},${alpha})`;
  }
  if (process.env.TAMAGUI_TARGET === "web") {
    if (typeof color === "string") {
      return color;
    }
  }
};
var normalizeColor_default = normalizeColor;
export {
  normalizeColor_default as default
};
//# sourceMappingURL=normalizeColor.js.map
